<template>
  <div class="iv-banner-wrapper">
    <div class="iv-type-page-wrapper">
      <Row>
        <Col
          :sm="~~size[0]"
          :md="~~size[0]"
          :xs="~~size[0]">
          <slot name="left"></slot>
        </Col>
        <Col
          :sm="~~size[1]"
          :md="~~size[1]"
          :xs="~~size[1]">
          <slot name="right"></slot>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { oneOf } from '@/utils'
export default {
  props: {
    ratio: {
      type: String,
      validate () {
        return oneOf(['24/0', '5/19', '17/7'])
      },
      default: '24/0'
    }
  },
  data () { return {} },
  computed: {
    size () {
      return this.ratio.split('/')
    }
  },
  components () {},
  created () {},
  methods () {}
}
</script>
<style lang="scss" scoped>
@import 'variable/variable.scss';
.iv-type-page-wrapper {
  width: $iv-page-type;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-layout/index.vue